import React, { useState, useEffect } from 'react';
import { MdArrowForwardIos, MdArrowBackIos } from 'react-icons/md';
import settings from '../../../data/settings';

const MenuNormalItem = (props) => {
  const [isItemHovered, setIsItemHovered] = useState(false);

  const [itemColor, setItemColor] = useState('fff');
  const [hoverItemColor, setHoverItemColor] = useState('#04cfd7');

  const [navigationContentAlignment, setNavigationContentAlignment] =
    useState('left');

  const itemStyle = {
    color: itemColor,
    cursor: 'pointer',
    display: 'table-cell',
  };

  const hoverItemStyle = {
    color: hoverItemColor,
    cursor: 'pointer',
    display: 'table-cell',
  };

  useEffect(() => {
    // Customizing colors
    setItemColor(settings.colors.font_color_regular);
    setHoverItemColor(settings.colors.link_hover_color);

    // Customizing navigation content alignment
    if (settings.alignment.navigation_content === 'left') {
      setNavigationContentAlignment('left');
    } else if (settings.alignment.navigation_content === 'center') {
      setNavigationContentAlignment('center');
    } else if (settings.alignment.navigation_content === 'right') {
      setNavigationContentAlignment('right');
    }
  }, []);

  return (
    <div
      className={`text-[18px] mx-8 py-3 hover:cursor-pointer viergrad-custom-menu-font-regular menu-item ${props.className}`}
      style={{
        display: 'flex',
        flexDirection:
          navigationContentAlignment === 'right'
            ? 'row-reverse'
            : navigationContentAlignment === 'left'
            ? 'row'
            : 'row',
        justifyContent:
          navigationContentAlignment === 'right'
            ? 'space-between'
            : navigationContentAlignment === 'left'
            ? 'space-between'
            : 'center',
      }}
      onClick={props.onClick}
    >
      {!props.multiLevel &&
      !props.submenuSecondLevel &&
      !props.submenuThirdLevel &&
      !props.submenuFourthLevel ? (
        <a
          href={props.href ? props.href : null}
          style={isItemHovered ? hoverItemStyle : itemStyle}
          onMouseEnter={() => setIsItemHovered(true)}
          onMouseLeave={() => setIsItemHovered(false)}
          target={props.target === '' ? '' : '_blank'}
        >
          <div class='viergrad-custom-menu-font-regular'>{props.name}</div>
        </a>
      ) : (
        <div
          class='viergrad-custom-menu-font-regular'
          style={isItemHovered ? hoverItemStyle : itemStyle}
          onMouseEnter={() => setIsItemHovered(true)}
          onMouseLeave={() => setIsItemHovered(false)}
        >
          {props.name}
        </div>
      )}
      {props.submenuSecondLevel ||
      props.submenuThirdLevel ||
      props.submenuFourthLevel ? (
        <div className='self-center' style={{ color: hoverItemColor }}>
          {navigationContentAlignment === 'right' ? (
            <MdArrowBackIos />
          ) : (
            <MdArrowForwardIos />
          )}
        </div>
      ) : (
        ''
      )}
    </div>
  );
};

export default MenuNormalItem;
